import React, { useEffect, useState, useRef } from "react";
import Switch from '@mui/material/Switch';
import { useNavigate, useLocation } from 'react-router-dom';
import FullscreenLoader from "../../../components/Common/FullscreenLoader.jsx";
import "../../../styles/Auth/product.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import ViewProductPopup from './viewProductPopup.jsx';
import Select from "react-select";
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
const ProductPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddProduct = location.pathname === '/products/add';
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Image',
        'Name',
        'Category',
        'SubCategory',
        'Code',
        'BarCode',
        'Qty In Stock',
        'Status',
        'Online',
        'Action',
    ];
    const fileInputRef = useRef(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [productImage, setProductImage] = useState(null);
    const [productImages, setProductImages] = useState([]);
    const [previewUrls, setPreviewUrls] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subcategories, setsubcategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [viewProductData, setViewProductData] = useState(null);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [searchQuery, setSearchQuery] = useState('');
    const [productsToDelete, setProductsToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editProductId, setEditProductId] = useState(null);
    const [fileName, setFileName] = useState("");
    const [attributes, setAttributes] = useState('');
    const [attributeErrors, setAttributeErrors] = useState({});
    const [errors, setErrors] = useState({});
    const [loadingPreview, setLoadingPreview] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        productType: '',
        productImageObject: '',
        productImagesObject: [],
        categoryId: '',
        subCategoryId: '',
        tax: '',
        attributes: [],
    });

    const handleAddProduct = async (e) => {
        e.preventDefault();
        
        // --- VALIDATION ---
        const validationErrors = validateProductForm(
            formData,
            productImage,
            productImages
        );
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) return;

        setErrors({});
        setLoading(true);
        
        try {
            const token = sessionStorage.getItem("sessionToken");
            const userId = sessionStorage.getItem("userId");

            /** ----------------------------
             *  UPLOAD MAIN IMAGE
             * ----------------------------
             */
            let uploadedSingleImage = null;

            if (productImage instanceof File && userId) {
                const uploadResult = await uploadFile(
                    `files/upload/${userId}`,
                    productImage
                );

                if (uploadResult?.status === 200) {
                    uploadedSingleImage = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Main image upload failed");
                    return;
                }
            }

            /** ----------------------------
             *  UPLOAD MULTIPLE IMAGES
             * ----------------------------
             */
            const uploadedMultiImages = [];

            if (Array.isArray(productImages) && productImages.length > 0 && userId) {

                for (let i = 0; i < productImages.length; i++) {
                    const file = productImages[i];

                    // safety check
                    if (!(file instanceof File)) continue;

                    const uploadResult = await uploadFile(
                        `files/upload/${userId}`,
                        file
                    );

                    if (uploadResult?.status === 200) {
                        uploadedMultiImages.push(uploadResult.data);
                    } else {
                        toast.error(
                            uploadResult?.message ||
                                `Image ${i + 1} upload failed`
                        );
                    }
                }
            }

            /** ----------------------------
             *  BUILD PRODUCT PAYLOAD
             * ----------------------------
             */
            const productData = {
                title: formData.title.trim(),
                description: formData.description.trim(),
                productType: formData.productType,
                categoryId: formData.categoryId,
                subCategoryId: formData.subCategoryId,
                tax: Number(formData.tax),
                productImageObject: uploadedSingleImage,
                productImagesObject: uploadedMultiImages,
                attributes: formData.attributes.map((attr) => ({
                    attributeId: attr.attributeId,
                    values: attr.values
                }))
            };

            console.log("Sending product data:", productData);

            /** ----------------------------
             *  SAVE PRODUCT
             * ----------------------------
             */
            const response = await postData("products/", productData, token);

            toast.success(response.message || "Product added successfully");

            /** ----------------------------
             *  RESET FORM
             * ----------------------------
             */
            setFormData({
                title: "",
                description: "",
                productType: "",
                categoryId: "",
                subCategoryId: "",
                attributes: [],
                tax: "",
                productImageObject: "",
                productImagesObject: []
            });

            // Reset images
            if (previewUrl) URL.revokeObjectURL(previewUrl);
            previewUrls.forEach((url) => URL.revokeObjectURL(url));

            setProductImage(null);
            setPreviewUrl(null);
            setProductImages([]);
            setPreviewUrls([]);

            navigate("/products");
            triggerRefresh();
        } catch (error) {
            console.error("Add Product Error:", error);
            toast.error(error.message || "Add Product Failed");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchProducts(currentPage, limit, searchQuery);
    }, [currentPage, limit, refreshKey, searchQuery]);

    const fetchProducts = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            title: searchQuery?.trim() || ""
        }
        try {
            setLoading(true);
            const response = await getData('products/products', params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const productsList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setProducts(productsList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Products");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteProduct = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('sessionToken');
            const response = await deleteData(`products/product/${productsToDelete}`, token);
            toast.success(response.message || "Product deleted successfully");
            setProductsToDelete(null);
            fetchProducts(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Product");
        }
    }

    const handleUpdateProduct = async (e) => {
        e.preventDefault();
        const validationErrors = validateProductForm(formData, productImage, productImages);
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return; // Stop submit
        }
        try {
            const token = sessionStorage.getItem("sessionToken");
            const userId = sessionStorage.getItem("userId");

            // Step 1️⃣ Upload main single image (if updated)
            let updatedImageObject = formData.productImageObject;
            if (productImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, productImage);

                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }

            // Step 2️⃣ Upload multiple gallery images (append all properly)
            let updatedImagesObject = Array.isArray(formData.productImagesObject)
                ? [...formData.productImagesObject] // keep existing images
                : [];

            if (productImages && productImages.length > 0 && userId) {
                const uploadPromises = productImages.map((img) =>
                    uploadFile(`files/upload/${userId}`, img)
                );

                // Wait for all uploads to finish
                const uploadResults = await Promise.all(uploadPromises);

                uploadResults.forEach((result, index) => {
                    if (result?.status === 200 || result?.success) {
                        updatedImagesObject.push(result.data); // ✅ append
                    } else {
                        toast.error(result?.message || `Image ${index + 1} upload failed`);
                    }
                });
            }

            // Step 3️⃣ Build the final updated product data
            const updatedProductData = {
                title: formData.title,
                description: formData.description,
                productType: formData.productType,
                categoryId: formData.categoryId,
                subCategoryId: formData.subCategoryId,
                productImageObject: updatedImageObject,
                productImagesObject: updatedImagesObject,
                tax: formData.tax,
                sellingPrice: formData.sellingPrice,
                purchasePrice: formData.purchasePrice,
            };

            console.log("🧾 Updating Product with data:", updatedProductData);

            // Step 4️⃣ Send PUT API request
            const response = await putData(
                `products/product/${editProductId}`,
                updatedProductData,
                token
            );

            // Step 5️⃣ Handle success
            toast.success(response.message || "Product updated successfully");

            // Step 6️⃣ Reset form and UI state
            setFormData({
                title: "",
                description: "",
                productType: "",
                productImageObject: "",
                categoryId: "",
                subCategoryId: "",
                productImagesObject: "",
                tax: "",
                sellingPrice: "",
                purchasePrice: "",
            });

            setProductImage(null);
            setPreviewUrl(null);
            setProductImages([]);
            setPreviewUrls([]);
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchProducts(currentPage, limit);
            triggerRefresh();
        } catch (error) {
            console.error("❌ Error updating product:", error);
            toast.error("Error updating product.");
        }
    };

    const handleViewProduct = async (productId) => {
        try {
            setLoading(true);

            // Assuming sessionToken is from sessionStorage
            const sessionToken = sessionStorage.getItem("sessionToken");

            // Fetch data using your getData function
            const response = await getData(`products/product/${productId}`, sessionToken);

            // Check if response is already JSON
            const data = response?.data || response;

            // Set the view data
            setViewProductData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching Product:", error);
            toast.error(error.message || "Failed to fetch Product data");
        } finally {
            setLoading(false);
        }
    };

    const handleOpen = (categoryId) => {
        setProductsToDelete(categoryId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setProductsToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const params = {};
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('categories/categories', params, token);
                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setCategories(results);
            } catch (error) {
                console.error("Failed to load categories", error);
            }
        };

        const fetchAttributes = async () => {
            try {
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('attributes/attributes', {}, token);
                console.log("API Full Response: ", data);
                const results = data?.data?.results?.results || [];
                setAttributes(results);
            } catch (error) {
                console.error("Failed to fetch Attributes", error);
            }
        }

        fetchCategories();
        fetchAttributes();
    }, []);

    useEffect(() => {
        if (!formData.categoryId) {
            setsubcategories([]);
            return;
        }

        const fetchSubCategories = async () => {
            try {
                const token = sessionStorage.getItem("Token");

                const data = await getData(
                    `subcategories/category/${formData.categoryId}`,
                    {},   // NO params needed
                    token
                );

                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setsubcategories(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };

        fetchSubCategories();
    }, [formData.categoryId]);

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const handleToggle = async (productId, newStatus) => {
        try {
            const token = sessionStorage.getItem("sessionToken");

            const response = await putData(
                `products/product/${productId}`,
                { isActive: newStatus },    // send true or false
                token
            );

            toast.success(response.message || "Status updated!");

            triggerRefresh();
        } catch (error) {
            console.error("Toggle Error:", error);
            toast.error("Failed to update status");
        }
    };

    const handleToggleOnline = async (productId, newStatus) => {
        try {
            const token = sessionStorage.getItem("sessionToken");

            const response = await putData(
                `products/product/${productId}`,
                { isOnline: newStatus },    // send true or false
                token
            );

            toast.success(response.message || "Status updated!");

            triggerRefresh();
        } catch (error) {
            console.error("Toggle Error:", error);
            toast.error("Failed to update status");
        }
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#e6cf80',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    const validateProductForm = (formData, productImage, productImages) => {
        let errors = {};

        // Product Name
        if (!formData.title?.trim()) {
            errors.title = "Product name is required";
        }

        // Product Type
        if (!formData.productType) {
            errors.productType = "Please select a sale type";
        }

        // ⚡ Attribute validation for Online / Both
        if (formData.productType === "Online" || formData.productType === "Both") {

            // No attributes added at all?
            if (!formData.attributes || formData.attributes.length === 0) {
                errors.attributes = "At least one attribute is required";
            } else {
                // Validate each attribute row
                formData.attributes.forEach((attr, index) => {

                    // Attribute Name required
                    if (!attr.attributeId) {
                        errors[`attribute_${index}`] = `Attribute ${index + 1}: Please select an attribute`;
                    }

                    // Attribute Values Required
                    if (!attr.values || attr.values.length === 0) {
                        errors[`attribute_values_${index}`] = `Attribute ${index + 1}: Please select at least one value`;
                    }
                });
            }
        }

        // Category
        if (!formData.categoryId) {
            errors.categoryId = "Please select a category";
        }

        // Subcategory
        if (!formData.subCategoryId) {
            errors.subCategoryId = "Please select a subcategory";
        }

        // Tax
        if (!formData.tax) {
            errors.tax = "Tax percentage is required";
        } else if (isNaN(formData.tax) || formData.tax < 0) {
            errors.tax = "Enter a valid tax percentage";
        }

        // Single Main Image
        if (!productImage) {
            errors.ProductImage = "Main image is required";
        }

        // Gallery images
        if (!productImages || productImages.length === 0) {
            errors.ProductImages = "At least one gallery image is required";
        }

        if (productImages && productImages.length > 10) {
            errors.ProductImages = "Maximum 10 gallery images allowed";
        }

        return errors;
    };

    const removeGalleryImage = (index) => {
        setLoading(true);
        // Revoke URL to prevent memory leak
        URL.revokeObjectURL(previewUrls[index]);

        // Remove preview and file
        setPreviewUrls(prev => prev.filter((_, i) => i !== index));
        setProductImages(prev => prev.filter((_, i) => i !== index));
        setLoading(false);
    };


    return (
        <div className="product-layout">
            {loading && <FullscreenLoader />}
            <div className="product-content">
                <main className="product-main">
                    {isAddProduct ? (
                        <div className="add-Product-form">
                            <h3>Add Product</h3>
                            <form className="Product-form">
                                {/* ROW 1 — Product Name, Category */}
                                <div className="Product-form-row">
                                    <div className="Product-form-group full-width">
                                        <label className="input-label">
                                            Product Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Product name"
                                            className={`Product-input ${errors.title ? "input-error" : ""}`}
                                            onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
                                        />
                                        {errors.title && <p className="error-msg">{errors.title}</p>}
                                    </div>
                                    <div className="Product-form-group">
                                        <label className="input-label">Category<span className="required">*</span></label>
                                        <select
                                            className={`category-input ${errors.categoryId ? "input-error" : ""}`}
                                            value={formData.categoryId}
                                            onChange={(e) =>
                                                setFormData(prev => ({
                                                    ...prev,
                                                    categoryId: e.target.value,
                                                    subCategoryId: "", // reset selection
                                                }))
                                            }
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map(cat => (
                                                <option key={cat._id} value={cat._id}>
                                                    {cat.categoryName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.categoryId && <p className="error-msg">{errors.categoryId}</p>}
                                    </div>
                                </div>

                                {/* ROW 2 — Subcategory, Tax */}
                                <div className="Product-form-row three-col">                                   

                                    <div className="Product-form-group">
                                        <label className="input-label">Subcategory<span className="required">*</span></label>

                                        <select
                                            className={`category-input ${errors.subCategoryId ? "input-error" : ""}`}
                                            value={formData.subCategoryId}
                                            onChange={(e) =>
                                                setFormData(prev => ({ ...prev, subCategoryId: e.target.value }))
                                            }
                                            disabled={!formData.categoryId} // disable until category selected
                                        >
                                            <option value="">
                                                {formData.categoryId ? "Select Subcategory" : "Select category first"}
                                            </option>

                                            {subcategories.map(sub => (
                                                <option key={sub._id} value={sub._id}>
                                                    {sub.subCategoryName || sub.name}
                                                </option>
                                            ))}
                                        </select>

                                        {errors.subCategoryId && <p className="error-msg">{errors.subCategoryId}</p>}
                                    </div>


                                    <div className="Product-form-group">
                                        <label className="input-label">Tax (%)<span className="required">*</span></label>
                                        <input
                                            type="number"
                                            className={`Product-input ${errors.tax ? "input-error" : ""}`}
                                            placeholder="Enter Tax %"
                                            value={formData.tax}
                                            onChange={(e) => setFormData({ ...formData, tax: e.target.value })}
                                        />
                                        {errors.tax && <p className="error-msg">{errors.tax}</p>}
                                    </div>
                                </div>

                                {/* ROW 3 — Images */}
                                <div className="Product-form-row two-col">
                                    <div className="Product-form-group">
                                        <label className="input-label">Gallery Images<span className="required">*</span></label>
                                        <input
                                            type="file"
                                            multiple
                                            accept="image/*"
                                            className={`Product-input ${errors.ProductImages ? "input-error" : ""}`}
                                            onChange={(e) => {
                                                setLoadingPreview(true);
                                                let files = Array.from(e.target.files || []);

                                                // Safety check: keep only File objects
                                                files = files.filter(f => f instanceof File);

                                                if (files.length === 0) {
                                                    setLoadingPreview(false);
                                                    return;
                                                }

                                                if (files.length > 10) {
                                                    toast.error("Maximum 10 gallery images allowed");
                                                    setLoadingPreview(false);
                                                    return;
                                                }

                                                setProductImages(files);

                                                setTimeout(() => {
                                                    const previews = files.map((file) => URL.createObjectURL(file));
                                                    setPreviewUrls(previews);
                                                    setLoadingPreview(false);  // 🔥 Stop preview loader
                                                }, 200); 
                                            }}
                                        />
                                        {loadingPreview ? (
                                            <div className="preview-loader">
                                                <div className="spinner"></div>
                                                Loading images...
                                            </div>
                                        ) : (
                                            previewUrls.length > 0 && (
                                                <div className="image-preview-multiple">
                                                    {previewUrls.map((img, index) => (
                                                        <div key={index} className="preview-item">
                                                            <img src={img} alt={`preview-${index}`} />

                                                            <button
                                                                type="button"
                                                                className="remove-image-btn"
                                                                onClick={() => removeGalleryImage(index)}
                                                            >
                                                                ✕
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )
                                        )}
                                        {errors.ProductImages && <p className="error-msg">{errors.ProductImages}</p>}
                                    </div>

                                    <div className="Product-form-group">
                                        <label className="input-label">Main Image<span className="required">*</span></label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            className={`Product-input ${errors.ProductImage ? "input-error" : ""}`}
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setProductImage(file);
                                                setPreviewUrl(URL.createObjectURL(file));
                                            }}
                                        />
                                        {previewUrl && (
                                            <div className="image-preview">
                                                <img src={previewUrl} alt="Preview" />
                                            </div>
                                        )}
                                        {errors.ProductImage && <p className="error-msg">{errors.ProductImage}</p>}
                                    </div>
                                </div>

                                {/* ROW 4 — Description */}
                                <div className="Product-form-row">
                                    <div className="Product-form-group full-width">
                                        <label className="input-label">Description</label>
                                        <textarea
                                            rows={5}
                                            className="Product-input"
                                            placeholder="Enter product description..."
                                            value={formData.description}
                                            onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                                        />
                                    </div>
                                </div>

                                {/* ROW 5 — Sale Type */}
                                <div className="Product-form-row">
                                    <div className="Product-form-group full-width">
                                        <label className="input-label">Sale Type<span className="required">*</span></label>
                                        <select
                                            className={`category-input ${errors.productType ? "input-error" : ""}`}
                                            value={formData.productType}
                                            onChange={(e) =>
                                                setFormData(prev => ({ ...prev, productType: e.target.value }))
                                            }
                                        >
                                            <option value="">Select Product Type</option>
                                            <option value="Offline">Offline</option>
                                            <option value="Online">Online</option>
                                            <option value="Both">Both</option>
                                        </select>
                                        {errors.productType && <p className="error-msg">{errors.productType}</p>}
                                    </div>
                                </div>

                                {/* ROW 6 — Attributes (Separate Full Width Section) */}
                                {(formData.productType === "Online" || formData.productType === "Both") && (() => {

                                    // ⭐ Get selected subcategory
                                    const selectedSubcategory = subcategories.find(
                                        s => s._id === formData.subCategoryId
                                    );

                                    // ⭐ Filter only attributes linked with this subcategory
                                    const filteredAttributes = selectedSubcategory
                                        ? attributes.filter(a =>
                                            (selectedSubcategory.attributes || []).includes(a._id)
                                        )
                                        : [];

                                    return (
                                        <div className="attribute-section">

                                            {/* Error Message */}
                                            {errors.attributes && (
                                                <p className="error-msg" style={{ marginBottom: "10px" }}>
                                                    {errors.attributes}
                                                </p>
                                            )}

                                            <div className="attribute-header-row">
                                                <h3 className="attribute-title">Product Attributes</h3>

                                                <button
                                                    type="button"
                                                    className="add-attr-btn"
                                                    onClick={() =>
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            attributes: [
                                                                ...(prev.attributes || []),
                                                                { attributeId: "", values: [] }
                                                            ],
                                                        }))
                                                    }
                                                >
                                                    + Add Attribute
                                                </button>
                                            </div>

                                            {/* Attribute Rows */}
                                            {formData.attributes?.length > 0 && (
                                                <div className="attribute-rows">
                                                    {formData.attributes.map((attr, index) => {

                                                        // ⭐ Selected attribute from filtered list
                                                        const selectedAttr = filteredAttributes.find(a => a._id === attr.attributeId);

                                                        return (
                                                            <div key={index} className="attribute-card-container">

                                                                {/* Remove Row */}
                                                                <span
                                                                    className="attr-remove-icon"
                                                                    onClick={() => {
                                                                        const updated = formData.attributes.filter((_, i) => i !== index);
                                                                        setFormData({ ...formData, attributes: updated });
                                                                    }}
                                                                >
                                                                    ✕
                                                                </span>

                                                                {/* Select Attribute */}
                                                                <label className="input-label">Select Attribute</label>

                                                                <Select
                                                                    options={filteredAttributes.map(a => ({
                                                                        value: a._id,
                                                                        label: a.attributeName,
                                                                    }))}

                                                                    value={
                                                                        attr.attributeId
                                                                            ? {
                                                                                value: attr.attributeId,
                                                                                label:
                                                                                    filteredAttributes.find(a => a._id === attr.attributeId)
                                                                                        ?.attributeName || "",
                                                                            }
                                                                            : null
                                                                    }

                                                                    onChange={(selectedOption) => {
                                                                        const updated = [...formData.attributes];
                                                                        updated[index].attributeId = selectedOption.value;
                                                                        updated[index].values = []; // reset values on attribute change
                                                                        setFormData({ ...formData, attributes: updated });
                                                                    }}

                                                                    placeholder={filteredAttributes.length === 0
                                                                        ? "No attributes linked with this subcategory"
                                                                        : "Select Attribute"
                                                                    }

                                                                    isDisabled={filteredAttributes.length === 0}
                                                                    classNamePrefix="select"
                                                                />

                                                                {errors[`attribute_${index}`] && (
                                                                    <p className="error-msg">{errors[`attribute_${index}`]}</p>
                                                                )}

                                                                {/* Values Multi-Select */}
                                                                {selectedAttr && (
                                                                    <>
                                                                        <label className="input-label mt-2">Select Values</label>

                                                                        <Select
                                                                            isMulti
                                                                            options={
                                                                                selectedAttr.values
                                                                                    ?.filter(v => v.isActive)
                                                                                    ?.map(v => ({
                                                                                        value: v.value,
                                                                                        label: v.value,
                                                                                    }))
                                                                            }

                                                                            value={attr.values.map(v => ({ value: v, label: v }))}

                                                                            onChange={(selectedOptions) => {
                                                                                const updated = [...formData.attributes];
                                                                                updated[index].values = selectedOptions.map(opt => opt.value);
                                                                                setFormData({ ...formData, attributes: updated });
                                                                            }}

                                                                            classNamePrefix="select"
                                                                        />

                                                                        {errors[`attribute_values_${index}`] && (
                                                                            <p className="error-msg">{errors[`attribute_values_${index}`]}</p>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}

                                        </div>
                                    );
                                })()}


                                {/* FINAL BUTTONS */}
                                <div className="Product-buttons">
                                    <button className="add-Product-button" type="submit" onClick={handleAddProduct}>
                                        Add Product
                                    </button>
                                    <button className="cancel-Product-button" onClick={() => navigate("/products")}>
                                        Cancel
                                    </button>
                                </div>

                            </form>

                        </div>
                    ) : (
                        <>
                            <div className="product-widgets">
                                <div className="product-widgets-header">
                                    <h3>Products</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="product-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="add-product-buttons">
                                    {/* <button
                                        className="add-btn-product"
                                        onClick={() => fileInputRef.current.click()}
                                    >
                                        Bulk Upload
                                    </button>
                                    <input
                                        type="file"
                                        accept=".xlsx, .xls"
                                        style={{ display: "none" }}
                                        ref={fileInputRef}
                                        onChange={handleBulkUploadClick}
                                    /> */}
                                    <button className="add-btn-product" onClick={() => navigate('/products/add')}>+ Add Product</button>
                                </div>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {products.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No Products found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            products.map((product, index) => (
                                                <TableRow key={product._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                            <img
                                                                src={`${process.env.REACT_APP_API_URL}${product.productImageObject?.uri}` || "/assets/placeholder.png"}
                                                                alt={product.name}
                                                                style={{ width: 40, height: 40, borderRadius: '4px' }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{product.title}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{product?.categoryDetails.categoryName}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{product?.subCategoryDetails.subCategoryName}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{product?.productCode}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{product?.barCode}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{product?.quantityInStock}</Typography></TableCell>
                                                    <TableCell >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                                                            <Switch
                                                                checked={product.isActive}
                                                                onChange={(e) => handleToggle(product._id, e.target.checked)}   // send id + status
                                                                sx={{
                                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                                        color: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                        backgroundColor: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-track': {
                                                                        backgroundColor: '#C10000',
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                                                            <Switch
                                                                checked={product.isOnline}
                                                                onChange={(e) => handleToggleOnline(product._id, e.target.checked)}   // send id + status
                                                                sx={{
                                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                                        color: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                        backgroundColor: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-track': {
                                                                        backgroundColor: '#C10000',
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            <Icon icon={plusIcon} width={20} height={20} onClick={() => handleViewProduct(product._id)} />
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    title: product.title || '',
                                                                    productType: product.productType || '',
                                                                    description: product.description || '',
                                                                    categoryId: product.categoryId || '',
                                                                    subCategoryId: product.subCategoryId || '',
                                                                    sellingPrice: product.sellingPrice || '',
                                                                    purchasePrice: product.purchasePrice || '',
                                                                    tax: product.tax || '',
                                                                    quantityInStock: product.quantityInStock || '',
                                                                    attributes: product.attributes.map(a => ({
                                                                        attributeId: a.attributeId,     // selected attribute
                                                                        values: a.values                // selected values array
                                                                    }))
                                                                });
                                                                setPreviewUrl(
                                                                    product?.productImageObject?.uri
                                                                        ? `${process.env.REACT_APP_API_URL}${product.productImageObject.uri}`
                                                                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                );
                                                                if (Array.isArray(product?.productImagesObject)) {
                                                                    setPreviewUrls(
                                                                        product.productImagesObject.map((img) =>
                                                                            img?.uri
                                                                                ? `${process.env.REACT_APP_API_URL}${img.uri}`
                                                                                : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                        )
                                                                    );
                                                                } else if (product?.productImagesObject?.uri) {
                                                                    // Fallback for older data with a single object
                                                                    setPreviewUrls([
                                                                        `${process.env.REACT_APP_API_URL}${product.productImagesObject.uri}`,
                                                                    ]);
                                                                } else {
                                                                    setPreviewUrls([]);
                                                                }
                                                                setProductImage(null);
                                                                setEditProductId(product._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000' }}
                                                                onClick={() => handleOpen(product._id)}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="product-bottom">
                                <div className="product-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="product-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="product-section spacer"></div>
                                <div className="product-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-box">
                                        <Icon
                                        />
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Product" : "Add Product"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateProduct}>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="title">Title</label>
                                                        <input
                                                            type="text"
                                                            id="title"
                                                            value={formData.title}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    title: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="productType">Product Type</label>
                                                        <select
                                                            id="productType"
                                                            className="category-input"
                                                            value={formData.productType}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, productType: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select Product Type</option>
                                                            <option value='Online'>Online</option>
                                                            <option value='Offline'>Offline</option>
                                                            <option value='Both'>Both</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="categoryname" className="input-label">
                                                            Category Name
                                                        </label>
                                                        <select
                                                            id="categoryId"
                                                            className="category-input"
                                                            required
                                                            value={formData.categoryId}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, categoryId: e.target.value, subCategoryId: '' }))}
                                                        >
                                                            <option value="">Select Category</option>
                                                            {categories.map(cat => (
                                                                <option key={cat._id} value={cat._id}>
                                                                    {cat.categoryName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="subCategoryName" className="input-label">
                                                            Sub Category Name
                                                        </label>
                                                        <select
                                                            id="subCategoryId"
                                                            className="category-input"
                                                            required
                                                            value={formData.subCategoryId}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, subCategoryId: e.target.value }))}
                                                        >
                                                            <option value="">Select Subcategory</option>
                                                            {subcategories.map(subcat => (
                                                                <option key={subcat._id} value={subcat._id}>
                                                                    {subcat.subCategoryName || subcat.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="gst" className="input-label">GST Value</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            value={formData.tax}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, tax: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="description">Description</label>
                                                        <input
                                                            type="text"
                                                            id="description"
                                                            placeholder="Enter description"
                                                            value={formData.description}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    description: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">

                                                    <div className="form-group">
                                                        <label htmlFor="productImage">Product Image</label>
                                                        <input
                                                            type="file"
                                                            id="productImage"
                                                            accept="image/*"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                setProductImage(file);
                                                                setPreviewUrl(URL.createObjectURL(file));
                                                                setFileName(file.fileName);
                                                            }}
                                                        />
                                                        {previewUrl ? (
                                                            <div className="image-preview">
                                                                <img src={previewUrl} alt="Preview" />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="productImages">Product Images</label>
                                                        <input
                                                            type="file"
                                                            id="productImages"
                                                            accept="image/*"
                                                            multiple
                                                            onChange={(e) => {
                                                                const files = Array.from(e.target.files);
                                                                setProductImages(files);
                                                                setPreviewUrls(files.map((file) => URL.createObjectURL(file)));
                                                            }}
                                                        />

                                                        {previewUrls && previewUrls.length > 0 && (
                                                            <div className="image-preview-multiple">
                                                                {previewUrls.map((url, index) => (
                                                                    <div key={index} className="image-box">
                                                                        <img src={url} alt={`Preview ${index + 1}`} />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                {/* ⭐ ATTRIBUTES SECTION (Only if product type supports online) */}
                                                {(formData.productType === "Online" || formData.productType === "Both") && (
                                                    <div className="popup-attribute-section">

                                                        <h3 className="attribute-title">Product Attributes</h3>

                                                        {/* Show error */}
                                                        {errors.attributes && (
                                                            <p className="error-msg">{errors.attributes}</p>
                                                        )}

                                                        {/* + Add Attribute Button */}
                                                        <button
                                                            type="button"
                                                            className="add-attr-btn"
                                                            onClick={() =>
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    attributes: [...(prev.attributes || []), { attributeId: "", values: [] }]
                                                                }))
                                                            }
                                                        >
                                                            + Add Attribute
                                                        </button>

                                                        {/* Attribute Rows */}
                                                        {formData.attributes?.length > 0 && (
                                                            <div className="popup-attribute-rows">

                                                                {formData.attributes.map((attr, index) => {
                                                                    const selectedSub = subcategories.find(s => s._id === formData.subCategoryId);

                                                                    // Filter only allowed attributes for this subcategory
                                                                    const allowedAttributes = selectedSub?.attributes || [];

                                                                    // Find from master attribute list
                                                                    const filteredAttributes = attributes.filter(a =>
                                                                        allowedAttributes.includes(a._id)
                                                                    );

                                                                    // Find selected attribute meta
                                                                    const selectedAttribute = filteredAttributes.find(a => a._id === attr.attributeId);

                                                                    return (
                                                                        <div key={index} className="attribute-card">

                                                                            {/* DELETE ATTRIBUTE */}
                                                                            <span
                                                                                className="attr-remove-icon"
                                                                                onClick={() => {
                                                                                    const updated = formData.attributes.filter((_, i) => i !== index);
                                                                                    setFormData({ ...formData, attributes: updated });
                                                                                }}
                                                                            >
                                                                                ✕
                                                                            </span>

                                                                            {/* SELECT ATTRIBUTE NAME */}
                                                                            <label>Select Attribute</label>
                                                                            <Select
                                                                                options={filteredAttributes.map(a => ({
                                                                                    value: a._id,
                                                                                    label: a.attributeName
                                                                                }))}
                                                                                value={
                                                                                    attr.attributeId
                                                                                        ? {
                                                                                            value: attr.attributeId,
                                                                                            label:
                                                                                                filteredAttributes.find(a => a._id === attr.attributeId)
                                                                                                    ?.attributeName || ""
                                                                                        }
                                                                                        : null
                                                                                }
                                                                                onChange={(opt) => {
                                                                                    const updated = [...formData.attributes];
                                                                                    updated[index].attributeId = opt.value;
                                                                                    updated[index].values = []; // reset values
                                                                                    setFormData({ ...formData, attributes: updated });
                                                                                }}
                                                                                placeholder="Select Attribute"
                                                                                classNamePrefix="select"
                                                                            />

                                                                            {/* VALIDATION */}
                                                                            {errors[`attribute_${index}`] && (
                                                                                <p className="error-msg">{errors[`attribute_${index}`]}</p>
                                                                            )}

                                                                            {/* MULTI SELECT VALUES */}
                                                                            {selectedAttribute && (
                                                                                <>
                                                                                    <label>Select Values</label>
                                                                                    <Select
                                                                                        isMulti
                                                                                        options={selectedAttribute.values
                                                                                            .filter(v => v.isActive)
                                                                                            .map(v => ({
                                                                                                value: v.value,
                                                                                                label: v.value
                                                                                            }))}
                                                                                        value={(attr.values || []).map(v => ({
                                                                                            value: v,
                                                                                            label: v
                                                                                        }))}
                                                                                        onChange={(opts) => {
                                                                                            const updated = [...formData.attributes];
                                                                                            updated[index].values = opts.map(o => o.value);
                                                                                            setFormData({ ...formData, attributes: updated });
                                                                                        }}
                                                                                        classNamePrefix="select"
                                                                                    />

                                                                                    {/* ERROR for values */}
                                                                                    {errors[`attribute_values_${index}`] && (
                                                                                        <p className="error-msg">{errors[`attribute_values_${index}`]}</p>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update Product" : "Add Product"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && products.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Products
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this Product?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: "#8D2629 " }} onClick={handleDeleteProduct}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                            {openViewPopup && (
                                <ViewProductPopup
                                    data={viewProductData}
                                    onClose={() => setOpenViewPopup(false)}
                                />
                            )}
                        </>
                    )
                    }

                </main >
            </div >
        </div >
    );
};

export default ProductPage;